import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const RedirectPage = () => {
  const history = useHistory();

  useEffect(() => {
    window.location.href = 'https://conecta.comunidad365.es';
  }, [history]);

  return (
    <div>
      Redireccionando a Conecta C365...
    </div>
  );
};

export default RedirectPage;